import { useLocation, useNavigate } from 'react-router-dom'
import { CalendarDashboard } from '../CalendarDashboard'
import { ImportManager } from '../ImportManager'
import { AnalyticsDashboard } from '../AnalyticsDashboard'

export const Calendar = () => {
  const location = useLocation()
  const navigate = useNavigate()
  
  const getActiveTab = () => {
    if (location.pathname.includes('import')) return 'import'
    if (location.pathname.includes('analytics')) return 'analytics'
    return 'events'
  }
  
  const activeTab = getActiveTab()

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold">News Calendar</h1>
        <p className="text-muted-foreground">Manage economic news events and automatic position closures</p>
      </div>

      <div className="flex space-x-2 border-b">
        {[
          { id: 'events', label: 'Calendar' },
          { id: 'import', label: 'Import' },
          { id: 'analytics', label: 'Analytics' }
        ].map(tab => (
          <button
            key={tab.id}
            onClick={() => navigate(`/calendar/${tab.id}`)}
            className={`px-4 py-2 border-b-2 transition-colors ${
              activeTab === tab.id 
                ? 'border-primary text-primary font-medium' 
                : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="mt-6">
        {activeTab === 'events' && <CalendarDashboard />}
        {activeTab === 'import' && <ImportManager />}
        {activeTab === 'analytics' && <AnalyticsDashboard />}
      </div>
    </div>
  )
}
